module.exports = __webpack_public_path__ + "assets/webgl/LM.3.jpg.67f14a12.webp";